import { useEffect } from "react";
import { subscribeSidebarNavigate } from "../utils/sidebarNavigation";

export function useCloseOnSidebarNavigate(onClose) {
  useEffect(() => subscribeSidebarNavigate(onClose), [onClose]);
}
